import React, { FC } from 'react';
import AcademyProductTemplate from '@components/AcademyProduct/AcademyProduct';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { IAcademyItem } from '../../interfaces/Calendar';
import ContentWrapper from '../../ui/Content/Content';
import { EmptyMessage, Wrapper } from './AcademyProducts.elements';

interface AcademyProductsProps {
    events: IAcademyItem[];
    eventsCount: number;
}

const AcademyProductsTemplate: FC<AcademyProductsProps> = ({ events, eventsCount }) => {
    const { t } = useTranslation();

    return (
        <ContentWrapper mobileSidePadding={20}>
            <TitleTemplate tagType={TitleTagTypes.H2} isBlack>
                {t('academy.trainings.title')}
            </TitleTemplate>
            {eventsCount > 0 ? (
                <Wrapper>
                    {events
                        ?.sort((eventA, eventB) => (new Date(eventA.date_from) < new Date(eventB.date_from) ? -1 : 1))
                        ?.map((event, key) => (
                            <AcademyProductTemplate event={event} key={key} />
                        ))}
                </Wrapper>
            ) : (
                <EmptyMessage>{t('academy.trainings.emptyMessage')}</EmptyMessage>
            )}
        </ContentWrapper>
    );
};
export default AcademyProductsTemplate;
